import { Form, Modal, notification, Input } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import { updateGroupName, getGroups } from "store/slices/groupsSlice"; 

const EditGroupNameModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { isModalOpen, modalType, modalProps } = useSelector((state) => state.modals);
  const { loading } = useSelector((state) => state.groups);

  const open = isModalOpen && modalType === "edit_group_name";
  const groupId = modalProps?.groupId;
  const currentName = modalProps?.currentName;

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ groupName: currentName });
    }
  }, [open, currentName, form]);

  const onSubmit = async (values) => {
    try {
      await dispatch(updateGroupName({ 
        groupId, 
        groupName: values.groupName 
      })).unwrap();

      notification.success({
        message: t("common.success"),
        description: t("groups.edit.success"),
      });

      dispatch(getGroups()); 
      onClose();
    } catch (error) {
      notification.error({
        message: t("common.error"),
        description: error?.message || t("common.error.generic"),
      });
    }
  };

  const onClose = () => {
    form.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={t("groups.edit.title") || "Edit Group Name"}
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
      destroyOnClose
      centered
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="groupName"
          label={t("groups.crud.form.label.name")}
          rules={[{ required: true, message: t("groups.crud.form.label.name.required") }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditGroupNameModal;